// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"678":"a4be28b237e9280c6bc8","731":"772eac98d57841ee6a5b","843":"e73ace99f0d191d663cb","883":"e8250b8ce786b6b9dd28"}[chunkId] + ".js";
};